<script setup>
import CMSCalls from '@core/api/modules/CMSCalls'
import { StrapiBlocks } from 'vue-strapi-blocks-renderer'

definePage({
  meta: {
    layout: 'default',

    // authenticatedOnly: true,
  },
})

const homepageData = ref(null)
const apiBaseUrl = import.meta.env.VITE_CMS_API_BASE_URL

onMounted(async () => {
  const response = await CMSCalls.fetchSinglePage('home?populate=*')

  console.log('API Response:', response.data) // Debugging statement
  homepageData.value = response.data
})
</script>

<template>
  <div
    v-if="homepageData"
    class="container"
  >
    <!-- Title -->
    <h1 class="title">
      {{ homepageData.Title }}
    </h1>

    <!-- Intro + Image Row -->
    <div class="intro-section">
      <p class="intro-text">
        {{ homepageData.Intro }}
      </p>
      <img
        v-if="homepageData.intro_image.length"
        :src="`${apiBaseUrl}${homepageData.intro_image[0].url}`"
        alt="Intro Image"
        class="intro-image"
      >
    </div>

    <!-- Content Blocks -->
    <div class="content-blocks">
      <div
        v-for="(block, index) in homepageData.Content_Block"
        :key="index"
        class="block"
      >
        <h2>{{ block.Title }}</h2>
        <StrapiBlocks
          v-if="block.Text"
          :content="block.Text"
        />
      </div>
    </div>

    <!-- Legal -->
    <div class="block">
      <StrapiBlocks
        v-if="homepageData.legal"
        :content="homepageData.legal"
      />
    </div>
  </div>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Title Styling */
.title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

/* Intro Section */
.intro-section {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
}

.intro-text {
  flex: 1;
  font-size: 1.2rem;
  line-height: 1.6;
}

.intro-image {
  flex: 1;
  max-width: 50%;
  height: auto;
  border-radius: 10px;
}

/* Content Blocks */
.content-blocks {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
  gap: 20px;
}

.block {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.block h2 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.block p {
  font-size: 1rem;
  line-height: 1.5;
}
</style>

